import React, { useEffect, createElement } from 'react';
import { CheckCircleIcon, CalendarIcon } from 'lucide-react';
export function BookCallSection() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const scrollToTypeform = () => {
    const typeformElement = document.getElementById('typeform-embed');
    if (typeformElement) {
      typeformElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="py-12 sm:py-16 md:py-20 bg-orange-200" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-8 sm:mb-10" data-id="element-16">
          <button className="bg-white text-orange-700 px-5 py-2.5 sm:px-6 sm:py-3 rounded-full font-semibold shadow-md hover:shadow-lg transition mb-4 sm:mb-6 text-sm sm:text-base inline-flex items-center gap-2" data-id="element-17">
            <CalendarIcon className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-18" />
            Programa tu sesión de estrategia abajo
          </button>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-orange-900 mb-3 sm:mb-4 italic leading-tight px-2" data-id="element-19">
            Agenda tu Sesión Estratégica: Claridad, Plan y Acción
          </h2>
        </div>
        <div id="typeform-embed" className="max-w-5xl mx-auto bg-white rounded-xl sm:rounded-2xl shadow-2xl p-4 sm:p-6 md:p-8 mb-8 sm:mb-10 md:mb-12" data-id="element-20">
          <div data-tf-live="01K9JKB3M8T78V0TXDXY3SRHCP" style={{
          width: '100%',
          height: '500px'
        }} className="sm:h-[600px]" data-id="element-21"></div>
        </div>
        <div className="max-w-4xl mx-auto text-center mb-8 sm:mb-10" data-id="element-22">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-2 px-2 leading-tight" data-id="element-23">
            En esta llamada,{' '}
            <span className="text-orange-700 italic" data-id="element-24">obtendrás</span>
          </h3>
        </div>
        <div className="max-w-3xl mx-auto space-y-4 sm:space-y-6 mb-10 sm:mb-12" data-id="element-25">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3 sm:gap-4 bg-white p-4 sm:p-5 rounded-lg shadow-sm" data-id="element-26">
              <CheckCircleIcon className="h-6 w-6 sm:h-7 sm:w-7 text-orange-600 flex-shrink-0 mt-0.5 sm:mt-1" fill="currentColor" data-id="element-27" />
              <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed" data-id="element-28">
                <span className="font-bold text-orange-700" data-id="element-29">
                  {benefit.number}
                </span>{' '}
                {benefit.text}
              </p>
            </div>)}
        </div>
        <div className="text-center" data-id="element-30">
          <button onClick={scrollToTypeform} className="bg-orange-700 text-white font-bold py-3 px-8 sm:py-4 sm:px-12 rounded-lg text-base sm:text-lg md:text-xl shadow-lg hover:bg-orange-800 transition duration-300 w-full sm:w-auto" data-id="element-31">
            Reserva tu sesión ahora
            <div className="text-xs mt-1 font-normal uppercase tracking-wide" data-id="element-32">
              Plan paso a paso con IA: landing, VSL, anuncios y emails listos
            </div>
          </button>
        </div>
      </div>
    </section>;
}
const benefits = [{
  number: '1-',
  text: 'Diagnóstico personalizado (10–15 min): evaluamos tu nicho, oferta y estado actual; identificamos cuellos de botella y oportunidades rápidas.'
}, {
  number: '2-',
  text: 'Ruta de 4 semanas: te muestro el plan exacto del Bootcamp (oferta+copy, landing+VSL, anuncios+emails+tracking, optimización+escalado) con entregables semanales.'
}, {
  number: '3-',
  text: 'Auditoría express de oferta y mensaje: te llevas un borrador de promesa clara y un checklist de persuasión para mejorar tu conversión.'
}, {
  number: '4-',
  text: 'Pack de ejemplos y plantillas: revisamos modelos de landing, guion VSL (Hook→Verdad→Prueba→Oferta→CTA), anuncios, emails y la sheet de métricas con UTMs.'
}, {
  number: '5-',
  text: 'Siguiente paso decidido: definimos si el Bootcamp encaja contigo, el plan de arranque de la Semana 1 y tu primer micro-objetivo de 7 días.'
}];